// Global data-testid constants
export const AUTH = {
  loginEmail: "auth-login-email",
  loginPassword: "auth-login-password",
  loginSubmit: "auth-login-submit",
  loginGoogle: "auth-login-google",
  signupName: "auth-signup-name",
  signupEmail: "auth-signup-email",
  signupPassword: "auth-signup-password",
  signupConfirm: "auth-signup-confirm",
  signupTerms: "auth-signup-terms",
  signupSubmit: "auth-signup-submit",
  goToSignup: "auth-go-signup",
  goToLogin: "auth-go-login",
  logoutBtn: "auth-logout-button",
};

export const NAV = {
  topBar: "topnav-bar",
  hamburger: "topnav-hamburger",
  themeToggle: "topnav-theme-toggle",
  mobileToggle: "topnav-mobile-toggle",
  avatar: "topnav-avatar",
  drawer: "side-drawer",
  drawerOverlay: "side-drawer-overlay",
  drawerClose: "side-drawer-close",
  bottomInput: "bottom-input",
  bottomMic: "bottom-mic-button",
  bottomSend: "bottom-input-send",
};

export const DRAWER = {
  itemHome: "drawer-item-home",
  itemCalendar: "drawer-item-calendar",
  itemMessaging: "drawer-item-messaging",
  itemGeo: "drawer-item-geolocation",
  itemHajj: "drawer-item-hajj",
  itemMurshid: "drawer-item-murshid",
  itemProfile: "drawer-item-profile",
  itemSettings: "drawer-item-settings",
  itemTerms: "drawer-item-terms",
  itemLogout: "drawer-item-logout",
  comingSoonLabel: "drawer-coming-soon-label",
};

export const DASH = {
  greeting: "dashboard-greeting",
  prayerWidget: "dashboard-prayer-widget",
  tileCalendar: "dashboard-tile-calendar",
  tileMessaging: "dashboard-tile-messaging",
  tileGeo: "dashboard-tile-geolocation",
  tileHajj: "dashboard-tile-hajj",
  tileMurshid: "dashboard-tile-murshid",
  tileProfile: "dashboard-tile-profile",
};

export const CAL = {
  newEventBtn: "calendar-new-event",
  eventTitle: "calendar-event-title",
  eventStart: "calendar-event-start",
  eventType: "calendar-event-type",
  eventSave: "calendar-event-save",
  eventCard: "calendar-event-card",
  // v2 (Google-style rebuild)
  viewMonth: "calendar-view-month",
  viewWeek: "calendar-view-week",
  viewDay: "calendar-view-day",
  viewAgenda: "calendar-view-agenda",
  navPrev: "calendar-nav-prev",
  navNext: "calendar-nav-next",
  navToday: "calendar-nav-today",
  monthLabel: "calendar-month-label",
  dayCell: "calendar-day-cell",
  todayCircle: "calendar-today-circle",
  quickCreate: "calendar-quick-create",
  quickTitle: "calendar-quick-title",
  quickSave: "calendar-quick-save",
  quickMore: "calendar-quick-more",
  quickClose: "calendar-quick-close",
  modal: "calendar-event-modal",
  modalTitle: "calendar-modal-title",
  modalStartDate: "calendar-modal-start-date",
  modalStartTime: "calendar-modal-start-time",
  modalEndDate: "calendar-modal-end-date",
  modalEndTime: "calendar-modal-end-time",
  modalAllDay: "calendar-modal-all-day",
  modalLocation: "calendar-modal-location",
  modalDescription: "calendar-modal-description",
  modalReminder: "calendar-modal-reminder",
  modalRecurring: "calendar-modal-recurring",
  modalSave: "calendar-modal-save",
  modalCancel: "calendar-modal-cancel",
  eventDetail: "calendar-event-detail",
  eventEdit: "calendar-event-edit",
  eventDelete: "calendar-event-delete",
  gcalStatus: "calendar-gcal-status",
};

export const MURSHID = {
  input: "murshid-input",
  send: "murshid-send",
  bubble: "murshid-bubble",
  newSession: "murshid-new-session",
  emptyState: "murshid-empty-state",
  suggestionPill: "murshid-suggestion-pill",
  typingIndicator: "murshid-typing-indicator",
  realtimeStatus: "murshid-realtime-status",
};

export const TERMS = {
  acceptBtn: "terms-accept-button",
  closeBtn: "terms-close-button",
};


export const GEO = {
  page: "geolocation-page",
  searchInput: "geolocation-search-input",
  searchBtn: "geolocation-search-btn",
  resultItem: "geolocation-result-item",
  locateMe: "geolocation-locate-me",
  favHome: "geolocation-fav-home",
  favWork: "geolocation-fav-work",
  favAdd: "geolocation-fav-add",
  favItem: "geolocation-fav-item",
  favDelete: "geolocation-fav-delete",
  directionsBtn: "geolocation-directions-btn",
  modeDriving: "geolocation-mode-driving",
  modeWalking: "geolocation-mode-walking",
  modeTransit: "geolocation-mode-transit",
  modeBicycling: "geolocation-mode-bicycling",
  routeInfo: "geolocation-route-info",
  shareLink: "geolocation-share-link",
  shareCalendar: "geolocation-share-calendar",
  bottomSheet: "geolocation-bottom-sheet",
  errorBanner: "geolocation-error",
};
